import { render, staticRenderFns } from "./OfficerDetailsForm.vue?vue&type=template&id=350ef6c0&scoped=true&"
import script from "./OfficerDetailsForm.vue?vue&type=script&lang=js&"
export * from "./OfficerDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./OfficerDetailsForm.vue?vue&type=style&index=0&id=350ef6c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350ef6c0",
  null
  
)

export default component.exports